export default "__VITE_ASSET__2XnTtMav__"